






























































import { SfLink } from '~/components';
import {defineComponent, onMounted, onBeforeUnmount, ref, watch} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { CategoryTree } from '~/modules/GraphQL/types';
import {useUiState} from "~/composables";

export default defineComponent({
  name: 'HeaderNavigationSubcategories',
  components: {
    SfLink,
  },
  props: {
    currentCategory: {
      type: Object as PropType<CategoryTree | null>,
      default: () => null,
    },
  },
  setup(props) {
    const currentImageDesktop = ref<String>(props.currentCategory.image_desktop_url);
    const {
      toggleDesktopMenu,
      toggleMobileMenu,
    } = useUiState();

    watch(
      () => props.currentCategory,
      () => currentImageDesktop.value = props.currentCategory.image_desktop_url,
      { immediate: true, deep: true }
    )

    const setImage = (imageDesktopUrl) => {
      if (imageDesktopUrl) currentImageDesktop.value = imageDesktopUrl
    };

    const navigationMediaQuery = window.matchMedia('(max-width: 1023px)');
    const navigationSwitcher = (event) => {
      if (event.matches) {
        toggleMobileMenu();
        toggleDesktopMenu();
      }
    }
    onMounted(() => {
      navigationMediaQuery.addEventListener('change', navigationSwitcher);
    })

    onBeforeUnmount(() => {
      navigationMediaQuery.removeEventListener('change', navigationSwitcher);
    })
    return {
      currentImageDesktop,
      setImage,
    };
  },
});
